import ManageModelTable from './manageModelTable'

export default ManageModelTable
